import { uuid } from '@guestyci/foundation/utils';
import { setIn } from 'final-form';
import ObjectSchema from 'yup/lib/object';

const generateUUID = () => `ypa-uuid-${uuid()}`;

function getBrowserVersion(): { name: string; version: string } {
  const ua = navigator.userAgent;
  let tem;
  let M =
    ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) ||
    [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return {
      name: 'IE',
      version: tem[1] || '',
    };
  }

  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null)
      return {
        name: tem.slice(1).join(' ').replace('OPR', 'Opera'),
        version: tem[1],
      };
  }

  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  // eslint-disable-next-line no-cond-assign
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
  return {
    name: M[0],
    version: M[1],
  };
}

function validateFormValues(schema: ObjectSchema<any, any, any>) {
  return async function (values: any) {
    try {
      await schema.validate(values, { abortEarly: false });
    } catch (err) {
      return (err as any)?.inner?.reduce(
        (
          formError: Record<any, any>,
          innerError: { path: string; message: string }
        ) => setIn(formError, innerError.path, innerError.message),
        {}
      );
    }
  };
}

export default {
  validateFormValues,
  generateUUID,
  getBrowserVersion,
};
